
import { toast } from '../types'


export const sendToastMessage = data => ({
    type: toast.SEND_TOAST,
    payload: data
})